export const ORDER_TYPES = {
  TITLE: 'title',
  ARTIST: 'artist',
  ALBUM: 'album'
};
